import { render, staticRenderFns } from "./addBank.vue?vue&type=template&id=7d3e8995"
import script from "./addBank.vue?vue&type=script&lang=js"
export * from "./addBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports